import { createConfirmations } from 'src/utils/confirmations';
import type { Confirmations as ConfirmationsAPI } from 'utils/confirmations';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { MoveList } from 'chessboard/model/move-list/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';
import type { ContextMenu } from '../config/types';

type Confirmations = ConfirmationsAPI<typeof CONTEXT_MENU_ACTION_NAMES, undefined>;

/**
 * Create the clear analysis action
 */
export function createClearAnalysis(
  _store: Store,
  _storeActions: StoreActions,
): ContextMenu.Action {
  const confirmationAlert: Confirmations = createConfirmations();

  return {
    getDisplayName: () => MoveList.Translation.Actions.ClearAllAnalysis,
    action: CONTEXT_MENU_ACTION_NAMES.ClearAnalysis,
    handler,

    /**
     * We always want to show this action
     */
    isVisible() {
      return true;
    },
  };

  /**
   * Clear all analysis.
   * Remove any variations, comments, annotations, and additional annotations
   */
  function handler({ node, game }: ContextMenu.ActionHandlerContext) {
    confirmationAlert.requestConfirmation({
      action: onConfirmation,
      data: undefined,
      text: 'Are you sure you want to clear all analysis?',
      type: 'ClearAnalysis',
    });

    /**
     * Action to take if awaiting confirmation.
     */
    function onConfirmation() {
      const mainLine = game.getLine(0);

      if (!mainLine) {
        return;
      }

      // call the reset to main line function
      game.resetToMainLine();

      // remove annotations, comments, additional annotations on nodes on the main line
      mainLine.forEach((moveNode) => {
        // reset the node's comments and annotations
        game.updateNode(moveNode.ids, {
          additionalAnnotation: undefined,
          annotation: '',
          comment: undefined,
        });

        delete node.commands?.href;
        delete node.commands?.text;
      });

      // remove line comment on the main line
      if (mainLine.initComment) {
        game.updateLineComment(undefined, mainLine.id);
      }
    }
  }
}
